import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import UserManagement from '../views/UserManagement.vue'
import RegisteredUserAccounts from '../views/RegisteredUserAccounts.vue'
import ProductManagement from '../views/ProductManagement.vue'
import ProductCreate from '../views/ProductCreate.vue'
import OrderManagement from '../views/OrderManagement.vue'
import OrdersSituation from '../views/OrdersSituation.vue'
import VoucherManagement from '../views/VoucherManagement.vue'
import SubscriptionManagement from '../views/SubscriptionManagement.vue'
import CashierSystem from '../views/CashierSystem.vue'
import CashierEntry from '../views/CashierEntry.vue'
import EmployeeManagement from '../views/EmployeeManagement.vue'
import StoreAttendance from '../views/StoreAttendance.vue'
import AttendanceCalendar from '../views/AttendanceCalendar.vue'
import RiderInfo from '../views/RiderInfo.vue'
import RiderDispatch from '../views/RiderDispatch.vue'
import RiderReceiptManagement from '../views/RiderReceiptManagement.vue'
import RiderTodayDelivery from '../views/RiderTodayDelivery.vue'
import PersonalCenter from '../views/PersonalCenter.vue'
import MemberLevelRules from '../views/MemberLevelRules.vue'
import UserLevelLog from '../views/UserLevelLog.vue'
import PointsMall from '../views/PointsMall.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import UserAgreement from '../views/UserAgreement.vue'
import InventoryDashboard from '../views/InventoryDashboard.vue'
import InventoryInboundLogs from '../views/InventoryInboundLogs.vue'
import InventoryOutboundLogs from '../views/InventoryOutboundLogs.vue'
import InventoryInOutReport from '../views/InventoryInOutReport.vue'
import MiniDecoration from '../views/MiniDecoration.vue'
import BannerManagement from '../views/BannerManagement.vue'
import StoreManagement from '../views/StoreManagement.vue'
import DisplayConfig from '../views/DisplayConfig.vue'
import GrouponSettings from '../views/GrouponSettings.vue'
import GrouponVerify from '../views/GrouponVerify.vue'
import PortalSite from '../views/PortalSite.vue'
import OperationLogs from '../views/OperationLogs.vue'
import DeleteRequestReview from '../views/DeleteRequestReview.vue'
import ExpiryManagement from '../views/ExpiryManagement.vue'
import DeferralQuery from '../views/DeferralQuery.vue'
import MealSchedulePanel from '../views/MealSchedulePanel.vue'
import EmailBatch from '../views/EmailBatch.vue'
import { getAdminToken, getIsLoggedIn, getUserInfo, ensureAuthSessionValid } from '../utils/auth'
import { isCashierDeskSessionValid, clearCashierDeskSession } from '../utils/cashierSession'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/',
      name: 'Dashboard',
      component: Dashboard,
      meta: { requiresAuth: true }
    },
    {
      path: '/users',
      name: 'UserManagement',
      component: UserManagement,
      meta: { requiresAuth: true }
    },
    {
      path: '/user-accounts',
      name: 'RegisteredUserAccounts',
      component: RegisteredUserAccounts,
      meta: { requiresAuth: true }
    },
    {
      path: '/products',
      name: 'ProductManagement',
      component: ProductManagement,
      meta: { requiresAuth: true }
    },
    {
      path: '/stores',
      name: 'StoreManagement',
      component: StoreManagement,
      meta: { requiresAuth: true }
    },
    {
      path: '/display-config',
      name: 'DisplayConfig',
      component: DisplayConfig,
      meta: { requiresAuth: true }
    },
    {
      path: '/groupon-settings',
      name: 'GrouponSettings',
      component: GrouponSettings,
      meta: { requiresAuth: true }
    },
    {
      path: '/groupon-verify',
      name: 'GrouponVerify',
      component: GrouponVerify,
      meta: { requiresAuth: true }
    },
    {
      path: '/products/create',
      name: 'ProductCreate',
      component: ProductCreate,
      meta: { requiresAuth: true }
    },
    {
      path: '/orders',
      name: 'OrderManagement',
      component: OrderManagement,
      meta: { requiresAuth: true }
    },
    {
      path: '/orders/situation',
      name: 'OrdersSituation',
      component: OrdersSituation,
      meta: { requiresAuth: true }
    },
    {
      path: '/cashier',
      name: 'Cashier',
      component: CashierEntry,
      meta: { requiresAuth: true }
    },
    {
      path: '/cashier-desk',
      name: 'CashierDesk',
      component: CashierSystem,
      meta: { requiresAuth: true, cashierDesk: true }
    },
    {
      path: '/vouchers',
      name: 'VoucherManagement',
      component: VoucherManagement,
      meta: { requiresAuth: true }
    },
    {
      path: '/subscriptions',
      name: 'SubscriptionManagement',
      component: SubscriptionManagement,
      meta: { requiresAuth: true }
    },
    {
      path: '/subscription-calendar',
      redirect: { path: '/meal-holiday-config', query: { tab: 'calendar' } }
    },
    {
      path: '/member/level-rules',
      name: 'MemberLevelRules',
      component: MemberLevelRules,
      meta: { requiresAuth: true }
    },
    {
      path: '/member/users',
      redirect: { path: '/users', query: { tab: 'levels' } }
    },
    {
      path: '/member/logs',
      name: 'UserLevelLog',
      component: UserLevelLog,
      meta: { requiresAuth: true }
    },
    {
      path: '/member/points-mall',
      name: 'PointsMall',
      component: PointsMall,
      meta: { requiresAuth: true }
    },
    {
      path: '/employees',
      name: 'EmployeeManagement',
      component: EmployeeManagement,
      meta: { requiresAuth: true }
    },
    {
      path: '/store-attendance',
      name: 'StoreAttendance',
      component: StoreAttendance,
      meta: { requiresAuth: true }
    },
    {
      path: '/attendance-calendar',
      name: 'AttendanceCalendar',
      component: AttendanceCalendar,
      meta: { requiresAuth: true }
    },
    {
      path: '/riders/info',
      name: 'RiderInfo',
      component: RiderInfo,
      meta: { requiresAuth: true }
    },
    {
      path: '/riders/today',
      name: 'RiderTodayDelivery',
      component: RiderTodayDelivery,
      meta: { requiresAuth: true }
    },
    {
      path: '/riders/map',
      name: 'RiderDispatch',
      component: RiderDispatch,
      meta: { requiresAuth: true }
    },
    {
      path: '/receipt',
      redirect: '/receipt/template'
    },
    {
      path: '/receipt/template',
      name: 'ReceiptTemplate',
      component: RiderReceiptManagement,
      meta: { requiresAuth: true, receiptTab: 'template' }
    },
    {
      path: '/receipt/print',
      name: 'ReceiptPrint',
      component: RiderReceiptManagement,
      meta: { requiresAuth: true, receiptTab: 'print' }
    },
    {
      path: '/riders/receipt',
      redirect: (to) => ({
        path: to.query && String(to.query.tab || '') === 'print' ? '/receipt/print' : '/receipt/template'
      })
    },
    {
      path: '/personal',
      name: 'PersonalCenter',
      component: PersonalCenter,
      meta: { requiresAuth: true }
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
      meta: { requiresAuth: false }
    },
    {
      path: '/user-agreement',
      name: 'UserAgreement',
      component: UserAgreement,
      meta: { requiresAuth: false }
    },
    {
      path: '/inventory/dashboard',
      name: 'InventoryDashboard',
      component: InventoryDashboard,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/inbound-logs',
      name: 'InventoryInboundLogs',
      component: InventoryInboundLogs,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/outbound-logs',
      name: 'InventoryOutboundLogs',
      component: InventoryOutboundLogs,
      meta: { requiresAuth: true }
    },
    {
      path: '/inventory/inout-report',
      name: 'InventoryInOutReport',
      component: InventoryInOutReport,
      meta: { requiresAuth: true }
    },
    {
      path: '/mini-decoration',
      name: 'MiniDecoration',
      component: MiniDecoration,
      meta: { requiresAuth: true }
    },
    {
      path: '/banner-management',
      name: 'BannerManagement',
      component: BannerManagement,
      meta: { requiresAuth: true }
    },
    {
      path: '/portal-site',
      name: 'PortalSite',
      component: PortalSite,
      meta: { requiresAuth: true }
    },
    {
      path: '/operation-logs',
      name: 'OperationLogs',
      component: OperationLogs,
      meta: { requiresAuth: true }
    },
    {
      path: '/delete-requests-review',
      name: 'DeleteRequestReview',
      component: DeleteRequestReview,
      meta: { requiresAuth: true }
    },
    {
      path: '/expiry-management',
      name: 'ExpiryManagement',
      component: ExpiryManagement,
      meta: { requiresAuth: true }
    },
    {
      path: '/deferral-query',
      name: 'DeferralQuery',
      component: DeferralQuery,
      meta: { requiresAuth: true }
    },
    {
      path: '/meal-holiday-config',
      name: 'MealSchedulePanel',
      component: MealSchedulePanel,
      meta: { requiresAuth: true }
    },
    {
      path: '/email-batch',
      name: 'EmailBatch',
      component: EmailBatch,
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  ensureAuthSessionValid({ touch: !!to.meta.requiresAuth })
  const isLoggedIn = getIsLoggedIn()
  const hasToken = !!(getAdminToken() && String(getAdminToken()).trim())
  const roleLabel = String((getUserInfo() && getUserInfo().roleLabel) || '').trim()
  const isStaffCashier = roleLabel === '员工' || roleLabel === '收银员'

  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/login')
  } else if (to.meta.requiresAuth && isLoggedIn && !hasToken) {
    next('/login')
  } else if (to.meta.cashierDesk && !isCashierDeskSessionValid()) {
    clearCashierDeskSession()
    next('/cashier')
  } else if (isStaffCashier && to.path === '/') {
    next('/orders')
  } else if (to.path === '/login' && isLoggedIn && hasToken) {
    next(isStaffCashier ? '/orders' : '/')
  } else if (to.path === '/orders' && to.query && String(to.query.tab || '') === 'settings') {
    next({ path: '/receipt/template' })
  } else if (to.path === '/orders' && to.query && String(to.query.tab || '') === 'search') {
    // 小程序订单已并入收银台订单，旧链接统一跳转
    next({ path: '/orders/situation', replace: true })
  } else {
    next()
  }
})

export default router